import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetListingDataQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataQuery = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'SeoAccordions' } & Pick<
                    Types.SeoAccordions,
                    | 'category'
                    | 'expanded'
                    | 'geo'
                    | 'name'
                    | 'propertyType'
                    | 'section'
                    | 'transactionType'
                > & {
                        rows?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Row' } & {
                                        links?: Types.Maybe<
                                            Array<
                                                Types.Maybe<
                                                    {
                                                        __typename?: 'Link';
                                                    } & Pick<
                                                        Types.Link,
                                                        | 'category'
                                                        | 'geo'
                                                        | 'propertyType'
                                                        | 'section'
                                                        | 'transactionType'
                                                        | 'uri'
                                                    >
                                                >
                                            >
                                        >;
                                    }
                                >
                            >
                        >;
                        links?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Link' } & Pick<
                                        Types.Link,
                                        | 'category'
                                        | 'geo'
                                        | 'propertyType'
                                        | 'section'
                                        | 'transactionType'
                                        | 'uri'
                                    >
                                >
                            >
                        >;
                    }
            >
        >
    >;
    discoverMore?: Types.Maybe<
        { __typename?: 'DiscoverMore' } & Pick<
            Types.DiscoverMore,
            'housePricesUri' | 'findAgentsUri'
        >
    >;
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<
            Types.Results,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    { __typename?: 'AnalyticsTaxonomy' } & Pick<
                        Types.AnalyticsTaxonomy,
                        | 'url'
                        | 'areaName'
                        | 'activity'
                        | 'brand'
                        | 'countryCode'
                        | 'countyAreaName'
                        | 'currencyCode'
                        | 'listingsCategory'
                        | 'outcode'
                        | 'outcodes'
                        | 'page'
                        | 'postalArea'
                        | 'radius'
                        | 'radiusAutoexpansion'
                        | 'regionName'
                        | 'resultsSort'
                        | 'searchGuid'
                        | 'searchIdentifier'
                        | 'section'
                        | 'searchLocation'
                        | 'viewType'
                        | 'searchResultsCount'
                        | 'expandedResultsCount'
                        | 'totalResults'
                        | 'emailAllFormShown'
                        | 'emailAllTotalAgents'
                        | 'bedsMax'
                        | 'bedsMin'
                        | 'priceMax'
                        | 'priceMin'
                        | 'location'
                        | 'propertyType'
                        | 'geoIdentifier'
                    >
                >;
                analyticsEcommerce?: Types.Maybe<
                    { __typename?: 'AnalyticsEcommerce' } & Pick<
                        Types.AnalyticsEcommerce,
                        'currencyCode'
                    > & {
                            impressions?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'AnalyticsEcommerceImpressions';
                                        } & Pick<
                                            Types.AnalyticsEcommerceImpressions,
                                            | 'id'
                                            | 'list'
                                            | 'position'
                                            | 'variant'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                adTargeting?: Types.Maybe<
                    { __typename?: 'AdTargeting' } & Pick<
                        Types.AdTargeting,
                        | 'activity'
                        | 'areaName'
                        | 'bedsMax'
                        | 'bedsMin'
                        | 'brand'
                        | 'brandPrimary'
                        | 'countyAreaName'
                        | 'countryCode'
                        | 'currencyCode'
                        | 'listingsCategory'
                        | 'outcode'
                        | 'outcodes'
                        | 'page'
                        | 'postalArea'
                        | 'priceMax'
                        | 'priceMin'
                        | 'propertyType'
                        | 'regionName'
                        | 'resultsSort'
                        | 'searchLocation'
                        | 'searchResultsCount'
                        | 'section'
                        | 'totalResults'
                        | 'url'
                        | 'viewType'
                    >
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Pick<
                        Types.Meta,
                        'title' | 'description' | 'canonicalUri'
                    >
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pick<
                        Types.Pagination,
                        | 'pageNumber'
                        | 'pageNumberMax'
                        | 'totalResults'
                        | 'totalResultsWasLimited'
                    >
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Listing' } & Pick<
                                        Types.Listing,
                                        | 'numberOfVideos'
                                        | 'numberOfImages'
                                        | 'numberOfFloorPlans'
                                        | 'numberOfViews'
                                        | 'listingId'
                                        | 'title'
                                        | 'publishedOnLabel'
                                        | 'publishedOn'
                                        | 'availableFrom'
                                        | 'isPremium'
                                        | 'flag'
                                        | 'priceTitle'
                                        | 'price'
                                        | 'alternativeRentFrequencyLabel'
                                        | 'address'
                                        | 'isNewHomesDevelopment'
                                    > & {
                                            priceDrop?: Types.Maybe<
                                                {
                                                    __typename?: 'PriceDrop';
                                                } & Pick<
                                                    Types.PriceDrop,
                                                    | 'lastPriceChangeDate'
                                                    | 'percentageChangeLabel'
                                                >
                                            >;
                                            highlights?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Highlight';
                                                        } & Pick<
                                                            Types.Highlight,
                                                            | 'description'
                                                            | 'label'
                                                            | 'url'
                                                        >
                                                    >
                                                >
                                            >;
                                            otherPropertyImages?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'SubImage';
                                                        } & Pick<
                                                            Types.SubImage,
                                                            | 'small'
                                                            | 'large'
                                                            | 'caption'
                                                        >
                                                    >
                                                >
                                            >;
                                            branch?: Types.Maybe<
                                                {
                                                    __typename?: 'Branch';
                                                } & Pick<
                                                    Types.Branch,
                                                    | 'name'
                                                    | 'branchDetailsUri'
                                                    | 'phone'
                                                    | 'logoUrl'
                                                    | 'branchId'
                                                >
                                            >;
                                            features?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Feature';
                                                        } & Pick<
                                                            Types.Feature,
                                                            'content' | 'iconId'
                                                        >
                                                    >
                                                >
                                            >;
                                            image?: Types.Maybe<
                                                { __typename?: 'Image' } & Pick<
                                                    Types.Image,
                                                    'src' | 'caption'
                                                > & {
                                                        responsiveImgList?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'ResponsiveImg';
                                                                    } & Pick<
                                                                        Types.ResponsiveImg,
                                                                        | 'width'
                                                                        | 'src'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                            >;
                                            transports?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Transport';
                                                        } & Pick<
                                                            Types.Transport,
                                                            | 'title'
                                                            | 'poiType'
                                                            | 'distanceInMiles'
                                                        > & {
                                                                features?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'TransportFeatures';
                                                                    } & Pick<
                                                                        Types.TransportFeatures,
                                                                        | 'zone'
                                                                        | 'tubeLines'
                                                                    >
                                                                >;
                                                            }
                                                    >
                                                >
                                            >;
                                            tags?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Tag';
                                                        } & Pick<
                                                            Types.Tag,
                                                            'content'
                                                        >
                                                    >
                                                >
                                            >;
                                            listingUris?: Types.Maybe<
                                                {
                                                    __typename?: 'ListingUris';
                                                } & Pick<
                                                    Types.ListingUris,
                                                    'contact' | 'detail'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Listing' } & Pick<
                                        Types.Listing,
                                        | 'numberOfVideos'
                                        | 'numberOfImages'
                                        | 'numberOfFloorPlans'
                                        | 'numberOfViews'
                                        | 'listingId'
                                        | 'title'
                                        | 'publishedOnLabel'
                                        | 'publishedOn'
                                        | 'availableFrom'
                                        | 'isPremium'
                                        | 'flag'
                                        | 'priceTitle'
                                        | 'price'
                                        | 'alternativeRentFrequencyLabel'
                                        | 'address'
                                    > & {
                                            priceDrop?: Types.Maybe<
                                                {
                                                    __typename?: 'PriceDrop';
                                                } & Pick<
                                                    Types.PriceDrop,
                                                    | 'lastPriceChangeDate'
                                                    | 'percentageChangeLabel'
                                                >
                                            >;
                                            highlights?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Highlight';
                                                        } & Pick<
                                                            Types.Highlight,
                                                            | 'description'
                                                            | 'label'
                                                            | 'url'
                                                        >
                                                    >
                                                >
                                            >;
                                            otherPropertyImages?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'SubImage';
                                                        } & Pick<
                                                            Types.SubImage,
                                                            | 'small'
                                                            | 'large'
                                                            | 'caption'
                                                        >
                                                    >
                                                >
                                            >;
                                            branch?: Types.Maybe<
                                                {
                                                    __typename?: 'Branch';
                                                } & Pick<
                                                    Types.Branch,
                                                    | 'name'
                                                    | 'branchDetailsUri'
                                                    | 'phone'
                                                    | 'logoUrl'
                                                    | 'branchId'
                                                >
                                            >;
                                            features?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Feature';
                                                        } & Pick<
                                                            Types.Feature,
                                                            'content' | 'iconId'
                                                        >
                                                    >
                                                >
                                            >;
                                            image?: Types.Maybe<
                                                { __typename?: 'Image' } & Pick<
                                                    Types.Image,
                                                    'src' | 'caption'
                                                > & {
                                                        responsiveImgList?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'ResponsiveImg';
                                                                    } & Pick<
                                                                        Types.ResponsiveImg,
                                                                        | 'width'
                                                                        | 'src'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                            >;
                                            transports?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Transport';
                                                        } & Pick<
                                                            Types.Transport,
                                                            | 'title'
                                                            | 'poiType'
                                                            | 'distanceInMiles'
                                                        > & {
                                                                features?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'TransportFeatures';
                                                                    } & Pick<
                                                                        Types.TransportFeatures,
                                                                        | 'zone'
                                                                        | 'tubeLines'
                                                                    >
                                                                >;
                                                            }
                                                    >
                                                >
                                            >;
                                            tags?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Tag';
                                                        } & Pick<
                                                            Types.Tag,
                                                            'content'
                                                        >
                                                    >
                                                >
                                            >;
                                            listingUris?: Types.Maybe<
                                                {
                                                    __typename?: 'ListingUris';
                                                } & Pick<
                                                    Types.ListingUris,
                                                    'contact' | 'detail'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Listing' } & Pick<
                                        Types.Listing,
                                        | 'numberOfVideos'
                                        | 'numberOfImages'
                                        | 'numberOfFloorPlans'
                                        | 'numberOfViews'
                                        | 'listingId'
                                        | 'title'
                                        | 'publishedOnLabel'
                                        | 'publishedOn'
                                        | 'availableFrom'
                                        | 'isPremium'
                                        | 'featuredType'
                                        | 'flag'
                                        | 'priceTitle'
                                        | 'price'
                                        | 'alternativeRentFrequencyLabel'
                                        | 'address'
                                        | 'isNewHomesDevelopment'
                                    > & {
                                            priceDrop?: Types.Maybe<
                                                {
                                                    __typename?: 'PriceDrop';
                                                } & Pick<
                                                    Types.PriceDrop,
                                                    | 'lastPriceChangeDate'
                                                    | 'percentageChangeLabel'
                                                >
                                            >;
                                            highlights?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Highlight';
                                                        } & Pick<
                                                            Types.Highlight,
                                                            | 'description'
                                                            | 'label'
                                                            | 'url'
                                                        >
                                                    >
                                                >
                                            >;
                                            otherPropertyImages?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'SubImage';
                                                        } & Pick<
                                                            Types.SubImage,
                                                            | 'small'
                                                            | 'large'
                                                            | 'caption'
                                                        >
                                                    >
                                                >
                                            >;
                                            branch?: Types.Maybe<
                                                {
                                                    __typename?: 'Branch';
                                                } & Pick<
                                                    Types.Branch,
                                                    | 'name'
                                                    | 'branchDetailsUri'
                                                    | 'phone'
                                                    | 'logoUrl'
                                                >
                                            >;
                                            features?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Feature';
                                                        } & Pick<
                                                            Types.Feature,
                                                            'content' | 'iconId'
                                                        >
                                                    >
                                                >
                                            >;
                                            image?: Types.Maybe<
                                                { __typename?: 'Image' } & Pick<
                                                    Types.Image,
                                                    'src' | 'caption'
                                                > & {
                                                        responsiveImgList?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'ResponsiveImg';
                                                                    } & Pick<
                                                                        Types.ResponsiveImg,
                                                                        | 'width'
                                                                        | 'src'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                            >;
                                            transports?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Transport';
                                                        } & Pick<
                                                            Types.Transport,
                                                            | 'title'
                                                            | 'poiType'
                                                            | 'distanceInMiles'
                                                        > & {
                                                                features?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'TransportFeatures';
                                                                    } & Pick<
                                                                        Types.TransportFeatures,
                                                                        | 'zone'
                                                                        | 'tubeLines'
                                                                    >
                                                                >;
                                                            }
                                                    >
                                                >
                                            >;
                                            tags?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Tag';
                                                        } & Pick<
                                                            Types.Tag,
                                                            'content'
                                                        >
                                                    >
                                                >
                                            >;
                                            listingUris?: Types.Maybe<
                                                {
                                                    __typename?: 'ListingUris';
                                                } & Pick<
                                                    Types.ListingUris,
                                                    'contact' | 'detail'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
                filters?: Types.Maybe<
                    { __typename?: 'Filters' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'FiltersFields' } & Pick<
                                        Types.FiltersFields,
                                        | 'group'
                                        | 'fieldName'
                                        | 'label'
                                        | 'isRequired'
                                        | 'inputType'
                                        | 'placeholder'
                                        | 'allowMultiple'
                                        | 'options'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Pick<
                        Types.Links,
                        'saveSearch' | 'createAlert'
                    >
                >;
                sortOrder?: Types.Maybe<
                    { __typename?: 'SortOrder' } & Pick<
                        Types.SortOrder,
                        'currentSortOrder'
                    > & {
                            options?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'SortOrderOption';
                                        } & Pick<
                                            Types.SortOrderOption,
                                            'i18NLabelKey' | 'value'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Pick<
                        Types.SeoBlurb,
                        'category' | 'transactionType'
                    >
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    { __typename?: 'SavedSearchAndAlerts' } & Pick<
                        Types.SavedSearchAndAlerts,
                        'uri'
                    > & {
                            currentFrequency?: Types.Maybe<
                                { __typename?: 'AlertFrequencyOption' } & Pick<
                                    Types.AlertFrequencyOption,
                                    'i18NLabelKey' | 'value'
                                >
                            >;
                        }
                >;
            }
    >;
};

export type UserFavouritesQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type UserFavouritesQuery = { __typename?: 'Query' } & {
    favourites?: Types.Maybe<
        { __typename?: 'Favourites' } & Pick<Types.Favourites, 'listings'>
    >;
};

export type FavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type FavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'saveFavouriteListing'
>;

export type UnfavouriteListingMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
}>;

export type UnfavouriteListingMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'deleteFavouriteListing'
>;

export type EmailAllMutationVariables = Types.Exact<{
    input: Types.EmailAllDetails;
}>;

export type EmailAllMutation = { __typename?: 'Mutation' } & {
    contactAgents?: Types.Maybe<
        { __typename?: 'EmailAllSubmission' } & {
            emailAll?: Types.Maybe<
                { __typename?: 'EmailAll' } & Pick<
                    Types.EmailAll,
                    'action' | 'showCaptcha'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllBranchContact';
                                    } & Pick<
                                        Types.EmailAllBranchContact,
                                        | 'checked'
                                        | 'featured'
                                        | 'label'
                                        | 'logo'
                                        | 'name'
                                        | 'type'
                                        | 'telephone'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                        branchesValidation?: Types.Maybe<
                            { __typename?: 'BranchesValidation' } & Pick<
                                Types.BranchesValidation,
                                'requiredError'
                            >
                        >;
                        formConfig?: Types.Maybe<
                            { __typename?: 'EmailAllFormConfig' } & {
                                fields?: Types.Maybe<
                                    Array<
                                        Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFields';
                                            } & {
                                                fieldset?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllFormConfigFieldset';
                                                    } & Pick<
                                                        Types.EmailAllFormConfigFieldset,
                                                        | 'hideLegend'
                                                        | 'i18NLegendKey'
                                                        | 'name'
                                                    > & {
                                                            fields?: Types.Maybe<
                                                                Array<
                                                                    Types.Maybe<
                                                                        {
                                                                            __typename?: 'EmailAllFormField';
                                                                        } & Pick<
                                                                            Types.EmailAllFormField,
                                                                            | 'name'
                                                                            | 'placeholder'
                                                                            | 'type'
                                                                            | 'value'
                                                                            | 'i18NLabelKey'
                                                                            | 'maxlength'
                                                                            | 'optional'
                                                                        > & {
                                                                                validationData?: Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllFormFieldValidation';
                                                                                    } & Pick<
                                                                                        Types.EmailAllFormFieldValidation,
                                                                                        | 'pattern'
                                                                                        | 'patternError'
                                                                                        | 'required'
                                                                                        | 'requiredError'
                                                                                    >
                                                                                >;
                                                                                options?: Types.Maybe<
                                                                                    Array<
                                                                                        Types.Maybe<
                                                                                            {
                                                                                                __typename?: 'EmailAllOption';
                                                                                            } & Pick<
                                                                                                Types.EmailAllOption,
                                                                                                | 'disabled'
                                                                                                | 'i18NLabelKey'
                                                                                                | 'label'
                                                                                                | 'selected'
                                                                                                | 'value'
                                                                                            >
                                                                                        >
                                                                                    >
                                                                                >;
                                                                            }
                                                                    >
                                                                >
                                                            >;
                                                        }
                                                >;
                                            }
                                        >
                                    >
                                >;
                            }
                        >;
                    }
            >;
            result?: Types.Maybe<
                { __typename?: 'EmailAllResult' } & Pick<
                    Types.EmailAllResult,
                    'leadIdentifier' | 'message'
                > & {
                        branches?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultBranches';
                                    } & Pick<
                                        Types.EmailAllResultBranches,
                                        | 'address'
                                        | 'branchDetailsUri'
                                        | 'branchDetailsUrl'
                                        | 'branchId'
                                        | 'companyId'
                                        | 'companyName'
                                        | 'logoUrl'
                                        | 'memberType'
                                        | 'name'
                                        | 'phone'
                                        | 'postcode'
                                    >
                                >
                            >
                        >;
                        trackingObjects?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllResultTracking';
                                    } & {
                                        ecommerce?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllResultEcommerce';
                                            } & {
                                                purchase?: Types.Maybe<
                                                    {
                                                        __typename?: 'EmailAllResultEcommercePurchase';
                                                    } & {
                                                        actionField?: Types.Maybe<
                                                            {
                                                                __typename?: 'EmailAllResultEcommercePurchaseAction';
                                                            } & Pick<
                                                                Types.EmailAllResultEcommercePurchaseAction,
                                                                | 'affiliation'
                                                                | 'id'
                                                                | 'revenue'
                                                            >
                                                        >;
                                                        products?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'EmailAllResultEcommerceProduct';
                                                                    } & Pick<
                                                                        Types.EmailAllResultEcommerceProduct,
                                                                        | 'brand'
                                                                        | 'category'
                                                                        | 'coupon'
                                                                        | 'id'
                                                                        | 'name'
                                                                        | 'position'
                                                                        | 'price'
                                                                        | 'quantity'
                                                                        | 'variant'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                                >;
                                            }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
            >;
        }
    >;
};

export type GetEmailAllQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetEmailAllQuery = { __typename?: 'Query' } & {
    emailAll?: Types.Maybe<
        { __typename?: 'EmailAll' } & Pick<
            Types.EmailAll,
            'action' | 'showCaptcha'
        > & {
                branches?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'EmailAllBranchContact' } & Pick<
                                Types.EmailAllBranchContact,
                                | 'checked'
                                | 'featured'
                                | 'label'
                                | 'logo'
                                | 'name'
                                | 'type'
                                | 'telephone'
                                | 'value'
                            >
                        >
                    >
                >;
                formConfig?: Types.Maybe<
                    { __typename?: 'EmailAllFormConfig' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'EmailAllFormConfigFields';
                                    } & {
                                        fieldset?: Types.Maybe<
                                            {
                                                __typename?: 'EmailAllFormConfigFieldset';
                                            } & Pick<
                                                Types.EmailAllFormConfigFieldset,
                                                | 'hideLegend'
                                                | 'i18NLegendKey'
                                                | 'name'
                                            > & {
                                                    fields?: Types.Maybe<
                                                        Array<
                                                            Types.Maybe<
                                                                {
                                                                    __typename?: 'EmailAllFormField';
                                                                } & Pick<
                                                                    Types.EmailAllFormField,
                                                                    | 'name'
                                                                    | 'placeholder'
                                                                    | 'type'
                                                                    | 'value'
                                                                    | 'i18NLabelKey'
                                                                    | 'maxlength'
                                                                    | 'optional'
                                                                > & {
                                                                        validationData?: Types.Maybe<
                                                                            {
                                                                                __typename?: 'EmailAllFormFieldValidation';
                                                                            } & Pick<
                                                                                Types.EmailAllFormFieldValidation,
                                                                                | 'pattern'
                                                                                | 'required'
                                                                            >
                                                                        >;
                                                                        options?: Types.Maybe<
                                                                            Array<
                                                                                Types.Maybe<
                                                                                    {
                                                                                        __typename?: 'EmailAllOption';
                                                                                    } & Pick<
                                                                                        Types.EmailAllOption,
                                                                                        | 'disabled'
                                                                                        | 'i18NLabelKey'
                                                                                        | 'label'
                                                                                        | 'selected'
                                                                                        | 'value'
                                                                                    >
                                                                                >
                                                                            >
                                                                        >;
                                                                    }
                                                            >
                                                        >
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export type GetListingDataV2QueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingDataV2Query = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'noAppend' | 'i18nLabelKey'
            >
        >
    >;
    redirects?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'Redirect' } & Pick<
                    Types.Redirect,
                    'code' | 'redirectUri'
                >
            >
        >
    >;
    seoAccordions?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'SeoAccordions' } & Pick<
                    Types.SeoAccordions,
                    | 'category'
                    | 'expanded'
                    | 'geo'
                    | 'name'
                    | 'propertyType'
                    | 'section'
                    | 'transactionType'
                > & {
                        rows?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Row' } & {
                                        links?: Types.Maybe<
                                            Array<
                                                Types.Maybe<
                                                    {
                                                        __typename?: 'Link';
                                                    } & Pick<
                                                        Types.Link,
                                                        | 'category'
                                                        | 'geo'
                                                        | 'propertyType'
                                                        | 'section'
                                                        | 'transactionType'
                                                        | 'uri'
                                                    >
                                                >
                                            >
                                        >;
                                    }
                                >
                            >
                        >;
                        links?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Link' } & Pick<
                                        Types.Link,
                                        | 'category'
                                        | 'geo'
                                        | 'propertyType'
                                        | 'section'
                                        | 'transactionType'
                                        | 'uri'
                                    >
                                >
                            >
                        >;
                    }
            >
        >
    >;
    discoverMore?: Types.Maybe<
        { __typename?: 'DiscoverMore' } & Pick<
            Types.DiscoverMore,
            'housePricesUri' | 'findAgentsUri'
        >
    >;
    searchResultsV2?: Types.Maybe<
        { __typename?: 'ResultsV2' } & Pick<
            Types.ResultsV2,
            'title' | 'userAlertId' | 'polyenc'
        > & {
                analyticsTaxonomy?: Types.Maybe<
                    { __typename?: 'AnalyticsTaxonomy' } & Pick<
                        Types.AnalyticsTaxonomy,
                        | 'url'
                        | 'areaName'
                        | 'activity'
                        | 'brand'
                        | 'countryCode'
                        | 'countyAreaName'
                        | 'currencyCode'
                        | 'listingsCategory'
                        | 'outcode'
                        | 'outcodes'
                        | 'page'
                        | 'postalArea'
                        | 'radius'
                        | 'radiusAutoexpansion'
                        | 'regionName'
                        | 'resultsSort'
                        | 'searchGuid'
                        | 'searchIdentifier'
                        | 'section'
                        | 'searchLocation'
                        | 'viewType'
                        | 'searchResultsCount'
                        | 'expandedResultsCount'
                        | 'totalResults'
                        | 'emailAllFormShown'
                        | 'emailAllTotalAgents'
                        | 'bedsMax'
                        | 'bedsMin'
                        | 'priceMax'
                        | 'priceMin'
                        | 'location'
                        | 'propertyType'
                        | 'geoIdentifier'
                    >
                >;
                analyticsEcommerce?: Types.Maybe<
                    { __typename?: 'AnalyticsEcommerce' } & Pick<
                        Types.AnalyticsEcommerce,
                        'currencyCode'
                    > & {
                            impressions?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'AnalyticsEcommerceImpressions';
                                        } & Pick<
                                            Types.AnalyticsEcommerceImpressions,
                                            | 'id'
                                            | 'list'
                                            | 'position'
                                            | 'variant'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                adTargeting?: Types.Maybe<
                    { __typename?: 'AdTargeting' } & Pick<
                        Types.AdTargeting,
                        | 'activity'
                        | 'areaName'
                        | 'bedsMax'
                        | 'bedsMin'
                        | 'brand'
                        | 'brandPrimary'
                        | 'countyAreaName'
                        | 'countryCode'
                        | 'currencyCode'
                        | 'listingsCategory'
                        | 'outcode'
                        | 'outcodes'
                        | 'page'
                        | 'postalArea'
                        | 'priceMax'
                        | 'priceMin'
                        | 'propertyType'
                        | 'regionName'
                        | 'resultsSort'
                        | 'searchLocation'
                        | 'searchResultsCount'
                        | 'section'
                        | 'totalResults'
                        | 'url'
                        | 'viewType'
                    >
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Pick<
                        Types.Meta,
                        'title' | 'description' | 'canonicalUri'
                    >
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pick<
                        Types.Pagination,
                        | 'pageNumber'
                        | 'pageNumberMax'
                        | 'totalResults'
                        | 'totalResultsWasLimited'
                    >
                >;
                results?: Types.Maybe<
                    { __typename?: 'ResultsList' } & {
                        main?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'ResultsItem' } & {
                                        data?: Types.Maybe<
                                            {
                                                __typename?: 'FeedListingItem';
                                            } & Pick<
                                                Types.FeedListingItem,
                                                'presentationType'
                                            > & {
                                                    listing?: Types.Maybe<
                                                        {
                                                            __typename?: 'Listing';
                                                        } & Pick<
                                                            Types.Listing,
                                                            | 'numberOfVideos'
                                                            | 'numberOfImages'
                                                            | 'numberOfFloorPlans'
                                                            | 'numberOfViews'
                                                            | 'listingId'
                                                            | 'title'
                                                            | 'publishedOnLabel'
                                                            | 'publishedOn'
                                                            | 'availableFrom'
                                                            | 'isPremium'
                                                            | 'flag'
                                                            | 'priceTitle'
                                                            | 'price'
                                                            | 'alternativeRentFrequencyLabel'
                                                            | 'address'
                                                            | 'isNewHomesDevelopment'
                                                        > & {
                                                                priceDrop?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'PriceDrop';
                                                                    } & Pick<
                                                                        Types.PriceDrop,
                                                                        | 'lastPriceChangeDate'
                                                                        | 'percentageChangeLabel'
                                                                    >
                                                                >;
                                                                highlights?: Types.Maybe<
                                                                    Array<
                                                                        Types.Maybe<
                                                                            {
                                                                                __typename?: 'Highlight';
                                                                            } & Pick<
                                                                                Types.Highlight,
                                                                                | 'description'
                                                                                | 'label'
                                                                                | 'url'
                                                                            >
                                                                        >
                                                                    >
                                                                >;
                                                                otherPropertyImages?: Types.Maybe<
                                                                    Array<
                                                                        Types.Maybe<
                                                                            {
                                                                                __typename?: 'SubImage';
                                                                            } & Pick<
                                                                                Types.SubImage,
                                                                                | 'small'
                                                                                | 'large'
                                                                                | 'caption'
                                                                            >
                                                                        >
                                                                    >
                                                                >;
                                                                branch?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'Branch';
                                                                    } & Pick<
                                                                        Types.Branch,
                                                                        | 'name'
                                                                        | 'branchDetailsUri'
                                                                        | 'phone'
                                                                        | 'logoUrl'
                                                                        | 'branchId'
                                                                    >
                                                                >;
                                                                features?: Types.Maybe<
                                                                    Array<
                                                                        Types.Maybe<
                                                                            {
                                                                                __typename?: 'Feature';
                                                                            } & Pick<
                                                                                Types.Feature,
                                                                                | 'content'
                                                                                | 'iconId'
                                                                            >
                                                                        >
                                                                    >
                                                                >;
                                                                image?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'Image';
                                                                    } & Pick<
                                                                        Types.Image,
                                                                        | 'src'
                                                                        | 'caption'
                                                                    > & {
                                                                            responsiveImgList?: Types.Maybe<
                                                                                Array<
                                                                                    Types.Maybe<
                                                                                        {
                                                                                            __typename?: 'ResponsiveImg';
                                                                                        } & Pick<
                                                                                            Types.ResponsiveImg,
                                                                                            | 'width'
                                                                                            | 'src'
                                                                                        >
                                                                                    >
                                                                                >
                                                                            >;
                                                                        }
                                                                >;
                                                                transports?: Types.Maybe<
                                                                    Array<
                                                                        Types.Maybe<
                                                                            {
                                                                                __typename?: 'Transport';
                                                                            } & Pick<
                                                                                Types.Transport,
                                                                                | 'title'
                                                                                | 'poiType'
                                                                                | 'distanceInMiles'
                                                                            > & {
                                                                                    features?: Types.Maybe<
                                                                                        {
                                                                                            __typename?: 'TransportFeatures';
                                                                                        } & Pick<
                                                                                            Types.TransportFeatures,
                                                                                            | 'zone'
                                                                                            | 'tubeLines'
                                                                                        >
                                                                                    >;
                                                                                }
                                                                        >
                                                                    >
                                                                >;
                                                                tags?: Types.Maybe<
                                                                    Array<
                                                                        Types.Maybe<
                                                                            {
                                                                                __typename?: 'Tag';
                                                                            } & Pick<
                                                                                Types.Tag,
                                                                                'content'
                                                                            >
                                                                        >
                                                                    >
                                                                >;
                                                                listingUris?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'ListingUris';
                                                                    } & Pick<
                                                                        Types.ListingUris,
                                                                        | 'contact'
                                                                        | 'detail'
                                                                    >
                                                                >;
                                                            }
                                                    >;
                                                }
                                        >;
                                    }
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'Listing' } & Pick<
                                        Types.Listing,
                                        | 'numberOfVideos'
                                        | 'numberOfImages'
                                        | 'numberOfFloorPlans'
                                        | 'numberOfViews'
                                        | 'listingId'
                                        | 'title'
                                        | 'publishedOnLabel'
                                        | 'publishedOn'
                                        | 'availableFrom'
                                        | 'isPremium'
                                        | 'flag'
                                        | 'priceTitle'
                                        | 'price'
                                        | 'alternativeRentFrequencyLabel'
                                        | 'address'
                                        | 'isNewHomesDevelopment'
                                    > & {
                                            priceDrop?: Types.Maybe<
                                                {
                                                    __typename?: 'PriceDrop';
                                                } & Pick<
                                                    Types.PriceDrop,
                                                    | 'lastPriceChangeDate'
                                                    | 'percentageChangeLabel'
                                                >
                                            >;
                                            highlights?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Highlight';
                                                        } & Pick<
                                                            Types.Highlight,
                                                            | 'description'
                                                            | 'label'
                                                            | 'url'
                                                        >
                                                    >
                                                >
                                            >;
                                            otherPropertyImages?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'SubImage';
                                                        } & Pick<
                                                            Types.SubImage,
                                                            | 'small'
                                                            | 'large'
                                                            | 'caption'
                                                        >
                                                    >
                                                >
                                            >;
                                            branch?: Types.Maybe<
                                                {
                                                    __typename?: 'Branch';
                                                } & Pick<
                                                    Types.Branch,
                                                    | 'name'
                                                    | 'branchDetailsUri'
                                                    | 'phone'
                                                    | 'logoUrl'
                                                    | 'branchId'
                                                >
                                            >;
                                            features?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Feature';
                                                        } & Pick<
                                                            Types.Feature,
                                                            'content' | 'iconId'
                                                        >
                                                    >
                                                >
                                            >;
                                            image?: Types.Maybe<
                                                { __typename?: 'Image' } & Pick<
                                                    Types.Image,
                                                    'src' | 'caption'
                                                > & {
                                                        responsiveImgList?: Types.Maybe<
                                                            Array<
                                                                Types.Maybe<
                                                                    {
                                                                        __typename?: 'ResponsiveImg';
                                                                    } & Pick<
                                                                        Types.ResponsiveImg,
                                                                        | 'width'
                                                                        | 'src'
                                                                    >
                                                                >
                                                            >
                                                        >;
                                                    }
                                            >;
                                            transports?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Transport';
                                                        } & Pick<
                                                            Types.Transport,
                                                            | 'title'
                                                            | 'poiType'
                                                            | 'distanceInMiles'
                                                        > & {
                                                                features?: Types.Maybe<
                                                                    {
                                                                        __typename?: 'TransportFeatures';
                                                                    } & Pick<
                                                                        Types.TransportFeatures,
                                                                        | 'zone'
                                                                        | 'tubeLines'
                                                                    >
                                                                >;
                                                            }
                                                    >
                                                >
                                            >;
                                            tags?: Types.Maybe<
                                                Array<
                                                    Types.Maybe<
                                                        {
                                                            __typename?: 'Tag';
                                                        } & Pick<
                                                            Types.Tag,
                                                            'content'
                                                        >
                                                    >
                                                >
                                            >;
                                            listingUris?: Types.Maybe<
                                                {
                                                    __typename?: 'ListingUris';
                                                } & Pick<
                                                    Types.ListingUris,
                                                    'contact' | 'detail'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
                filters?: Types.Maybe<
                    { __typename?: 'Filters' } & {
                        fields?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'FiltersFields' } & Pick<
                                        Types.FiltersFields,
                                        | 'group'
                                        | 'fieldName'
                                        | 'label'
                                        | 'isRequired'
                                        | 'inputType'
                                        | 'placeholder'
                                        | 'allowMultiple'
                                        | 'options'
                                        | 'value'
                                    >
                                >
                            >
                        >;
                    }
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Pick<
                        Types.Links,
                        'saveSearch' | 'createAlert'
                    >
                >;
                sortOrder?: Types.Maybe<
                    { __typename?: 'SortOrder' } & Pick<
                        Types.SortOrder,
                        'currentSortOrder'
                    > & {
                            options?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'SortOrderOption';
                                        } & Pick<
                                            Types.SortOrderOption,
                                            'i18NLabelKey' | 'value'
                                        >
                                    >
                                >
                            >;
                        }
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Pick<
                        Types.SeoBlurb,
                        'category' | 'transactionType'
                    >
                >;
                savedSearchAndAlerts?: Types.Maybe<
                    { __typename?: 'SavedSearchAndAlerts' } & Pick<
                        Types.SavedSearchAndAlerts,
                        'uri'
                    > & {
                            currentFrequency?: Types.Maybe<
                                { __typename?: 'AlertFrequencyOption' } & Pick<
                                    Types.AlertFrequencyOption,
                                    'i18NLabelKey' | 'value'
                                >
                            >;
                        }
                >;
            }
    >;
};

export const GetListingDataDocument = gql`
    query getListingData($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        redirects(path: $path) {
            code
            redirectUri
        }
        seoAccordions(path: $path) {
            category
            expanded
            geo
            name
            propertyType
            section
            transactionType
            rows {
                links {
                    category
                    geo
                    propertyType
                    section
                    transactionType
                    uri
                }
            }
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResults(path: $path) {
            analyticsTaxonomy {
                url
                areaName
                activity
                brand
                countryCode
                countyAreaName
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                section
                searchLocation
                viewType
                searchResultsCount
                expandedResultsCount
                totalResults
                emailAllFormShown
                emailAllTotalAgents
                bedsMax
                bedsMin
                priceMax
                priceMin
                location
                propertyType
                geoIdentifier
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            adTargeting {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                brandPrimary
                countyAreaName
                countryCode
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                regionName
                resultsSort
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                pageNumberMax
                totalResults
                totalResultsWasLimited
            }
            listings {
                regular {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                    isNewHomesDevelopment
                }
                extended {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                }
                featured {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    featuredType
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                    isNewHomesDevelopment
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            links {
                saveSearch
                createAlert
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            title
            userAlertId
            savedSearchAndAlerts {
                uri
                currentFrequency {
                    i18NLabelKey
                    value
                }
            }
            polyenc
        }
    }
`;

/**
 * __useGetListingDataQuery__
 *
 * To run a query within a React component, call `useGetListingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingDataQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetListingDataQuery, GetListingDataQueryVariables>(
        GetListingDataDocument,
        options
    );
}
export function useGetListingDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingDataQuery,
        GetListingDataQueryVariables
    >(GetListingDataDocument, options);
}
export type GetListingDataQueryHookResult = ReturnType<
    typeof useGetListingDataQuery
>;
export type GetListingDataLazyQueryHookResult = ReturnType<
    typeof useGetListingDataLazyQuery
>;
export type GetListingDataQueryResult = Apollo.QueryResult<
    GetListingDataQuery,
    GetListingDataQueryVariables
>;
export const UserFavouritesDocument = gql`
    query userFavourites {
        favourites {
            listings
        }
    }
`;

/**
 * __useUserFavouritesQuery__
 *
 * To run a query within a React component, call `useUserFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFavouritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFavouritesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<UserFavouritesQuery, UserFavouritesQueryVariables>(
        UserFavouritesDocument,
        options
    );
}
export function useUserFavouritesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        UserFavouritesQuery,
        UserFavouritesQueryVariables
    >(UserFavouritesDocument, options);
}
export type UserFavouritesQueryHookResult = ReturnType<
    typeof useUserFavouritesQuery
>;
export type UserFavouritesLazyQueryHookResult = ReturnType<
    typeof useUserFavouritesLazyQuery
>;
export type UserFavouritesQueryResult = Apollo.QueryResult<
    UserFavouritesQuery,
    UserFavouritesQueryVariables
>;
export const FavouriteListingDocument = gql`
    mutation favouriteListing($id: ID!) {
        saveFavouriteListing(id: $id)
    }
`;
export type FavouriteListingMutationFn = Apollo.MutationFunction<
    FavouriteListingMutation,
    FavouriteListingMutationVariables
>;

/**
 * __useFavouriteListingMutation__
 *
 * To run a mutation, you first call `useFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteListingMutation, { data, loading, error }] = useFavouriteListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFavouriteListingMutation(
    baseOptions?: Apollo.MutationHookOptions<
        FavouriteListingMutation,
        FavouriteListingMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        FavouriteListingMutation,
        FavouriteListingMutationVariables
    >(FavouriteListingDocument, options);
}
export type FavouriteListingMutationHookResult = ReturnType<
    typeof useFavouriteListingMutation
>;
export type FavouriteListingMutationResult =
    Apollo.MutationResult<FavouriteListingMutation>;
export type FavouriteListingMutationOptions = Apollo.BaseMutationOptions<
    FavouriteListingMutation,
    FavouriteListingMutationVariables
>;
export const UnfavouriteListingDocument = gql`
    mutation unfavouriteListing($id: ID!) {
        deleteFavouriteListing(id: $id)
    }
`;
export type UnfavouriteListingMutationFn = Apollo.MutationFunction<
    UnfavouriteListingMutation,
    UnfavouriteListingMutationVariables
>;

/**
 * __useUnfavouriteListingMutation__
 *
 * To run a mutation, you first call `useUnfavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfavouriteListingMutation, { data, loading, error }] = useUnfavouriteListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnfavouriteListingMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UnfavouriteListingMutation,
        UnfavouriteListingMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UnfavouriteListingMutation,
        UnfavouriteListingMutationVariables
    >(UnfavouriteListingDocument, options);
}
export type UnfavouriteListingMutationHookResult = ReturnType<
    typeof useUnfavouriteListingMutation
>;
export type UnfavouriteListingMutationResult =
    Apollo.MutationResult<UnfavouriteListingMutation>;
export type UnfavouriteListingMutationOptions = Apollo.BaseMutationOptions<
    UnfavouriteListingMutation,
    UnfavouriteListingMutationVariables
>;
export const EmailAllDocument = gql`
    mutation emailAll($input: EmailAllDetails!) {
        contactAgents(input: $input) {
            emailAll {
                action
                branches {
                    checked
                    featured
                    label
                    logo
                    name
                    type
                    telephone
                    value
                }
                branchesValidation {
                    requiredError
                }
                formConfig {
                    fields {
                        fieldset {
                            fields {
                                name
                                placeholder
                                type
                                value
                                i18NLabelKey
                                maxlength
                                optional
                                validationData {
                                    pattern
                                    patternError
                                    required
                                    requiredError
                                }
                                options {
                                    disabled
                                    i18NLabelKey
                                    label
                                    selected
                                    value
                                }
                            }
                            hideLegend
                            i18NLegendKey
                            name
                        }
                    }
                }
                showCaptcha
            }
            result {
                branches {
                    address
                    branchDetailsUri
                    branchDetailsUrl
                    branchId
                    companyId
                    companyName
                    logoUrl
                    memberType
                    name
                    phone
                    postcode
                }
                leadIdentifier
                message
                trackingObjects {
                    ecommerce {
                        purchase {
                            actionField {
                                affiliation
                                id
                                revenue
                            }
                            products {
                                brand
                                category
                                coupon
                                id
                                name
                                position
                                price
                                quantity
                                variant
                            }
                        }
                    }
                }
            }
        }
    }
`;
export type EmailAllMutationFn = Apollo.MutationFunction<
    EmailAllMutation,
    EmailAllMutationVariables
>;

/**
 * __useEmailAllMutation__
 *
 * To run a mutation, you first call `useEmailAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAllMutation, { data, loading, error }] = useEmailAllMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailAllMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EmailAllMutation,
        EmailAllMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<EmailAllMutation, EmailAllMutationVariables>(
        EmailAllDocument,
        options
    );
}
export type EmailAllMutationHookResult = ReturnType<typeof useEmailAllMutation>;
export type EmailAllMutationResult = Apollo.MutationResult<EmailAllMutation>;
export type EmailAllMutationOptions = Apollo.BaseMutationOptions<
    EmailAllMutation,
    EmailAllMutationVariables
>;
export const GetEmailAllDocument = gql`
    query getEmailAll($path: String!) {
        emailAll(path: $path) {
            action
            branches {
                checked
                featured
                label
                logo
                name
                type
                telephone
                value
            }
            formConfig {
                fields {
                    fieldset {
                        fields {
                            name
                            placeholder
                            type
                            value
                            i18NLabelKey
                            maxlength
                            optional
                            validationData {
                                pattern
                                required
                            }
                            options {
                                disabled
                                i18NLabelKey
                                label
                                selected
                                value
                            }
                        }
                        hideLegend
                        i18NLegendKey
                        name
                    }
                }
            }
            showCaptcha
        }
    }
`;

/**
 * __useGetEmailAllQuery__
 *
 * To run a query within a React component, call `useGetEmailAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAllQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetEmailAllQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEmailAllQuery,
        GetEmailAllQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEmailAllQuery, GetEmailAllQueryVariables>(
        GetEmailAllDocument,
        options
    );
}
export function useGetEmailAllLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEmailAllQuery,
        GetEmailAllQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEmailAllQuery, GetEmailAllQueryVariables>(
        GetEmailAllDocument,
        options
    );
}
export type GetEmailAllQueryHookResult = ReturnType<typeof useGetEmailAllQuery>;
export type GetEmailAllLazyQueryHookResult = ReturnType<
    typeof useGetEmailAllLazyQuery
>;
export type GetEmailAllQueryResult = Apollo.QueryResult<
    GetEmailAllQuery,
    GetEmailAllQueryVariables
>;
export const GetListingDataV2Document = gql`
    query getListingDataV2($path: String!) {
        breadcrumbs(path: $path) {
            label
            tracking
            uri
            noAppend
            i18nLabelKey
        }
        redirects(path: $path) {
            code
            redirectUri
        }
        seoAccordions(path: $path) {
            category
            expanded
            geo
            name
            propertyType
            section
            transactionType
            rows {
                links {
                    category
                    geo
                    propertyType
                    section
                    transactionType
                    uri
                }
            }
            links {
                category
                geo
                propertyType
                section
                transactionType
                uri
            }
        }
        discoverMore(path: $path) {
            housePricesUri
            findAgentsUri
        }
        searchResultsV2(input: { path: $path }) {
            analyticsTaxonomy {
                url
                areaName
                activity
                brand
                countryCode
                countyAreaName
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                section
                searchLocation
                viewType
                searchResultsCount
                expandedResultsCount
                totalResults
                emailAllFormShown
                emailAllTotalAgents
                bedsMax
                bedsMin
                priceMax
                priceMin
                location
                propertyType
                geoIdentifier
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            adTargeting {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                brandPrimary
                countyAreaName
                countryCode
                currencyCode
                listingsCategory
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                regionName
                resultsSort
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                pageNumberMax
                totalResults
                totalResultsWasLimited
            }
            results {
                main {
                    data {
                        ... on FeedListingItem {
                            listing {
                                numberOfVideos
                                numberOfImages
                                numberOfFloorPlans
                                numberOfViews
                                listingId
                                title
                                publishedOnLabel
                                publishedOn
                                availableFrom
                                priceDrop {
                                    lastPriceChangeDate
                                    percentageChangeLabel
                                }
                                isPremium
                                highlights {
                                    description
                                    label
                                    url
                                }
                                otherPropertyImages {
                                    small
                                    large
                                    caption
                                }
                                branch {
                                    name
                                    branchDetailsUri
                                    phone
                                    logoUrl
                                    branchId
                                }
                                features {
                                    content
                                    iconId
                                }
                                image {
                                    src
                                    caption
                                    responsiveImgList {
                                        width
                                        src
                                    }
                                }
                                transports {
                                    title
                                    poiType
                                    distanceInMiles
                                    features {
                                        zone
                                        tubeLines
                                    }
                                }
                                flag
                                listingId
                                priceTitle
                                price
                                alternativeRentFrequencyLabel
                                address
                                tags {
                                    content
                                }
                                listingUris {
                                    contact
                                    detail
                                }
                                isNewHomesDevelopment
                            }
                            presentationType
                        }
                    }
                }
                extended {
                    numberOfVideos
                    numberOfImages
                    numberOfFloorPlans
                    numberOfViews
                    listingId
                    title
                    publishedOnLabel
                    publishedOn
                    availableFrom
                    priceDrop {
                        lastPriceChangeDate
                        percentageChangeLabel
                    }
                    isPremium
                    highlights {
                        description
                        label
                        url
                    }
                    otherPropertyImages {
                        small
                        large
                        caption
                    }
                    branch {
                        name
                        branchDetailsUri
                        phone
                        logoUrl
                        branchId
                    }
                    features {
                        content
                        iconId
                    }
                    image {
                        src
                        caption
                        responsiveImgList {
                            width
                            src
                        }
                    }
                    transports {
                        title
                        poiType
                        distanceInMiles
                        features {
                            zone
                            tubeLines
                        }
                    }
                    flag
                    listingId
                    priceTitle
                    price
                    alternativeRentFrequencyLabel
                    address
                    tags {
                        content
                    }
                    listingUris {
                        contact
                        detail
                    }
                    isNewHomesDevelopment
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            links {
                saveSearch
                createAlert
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            title
            userAlertId
            savedSearchAndAlerts {
                uri
                currentFrequency {
                    i18NLabelKey
                    value
                }
            }
            polyenc
        }
    }
`;

/**
 * __useGetListingDataV2Query__
 *
 * To run a query within a React component, call `useGetListingDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetListingDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingDataV2Query({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingDataV2Query(
    baseOptions: Apollo.QueryHookOptions<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >(GetListingDataV2Document, options);
}
export function useGetListingDataV2LazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingDataV2Query,
        GetListingDataV2QueryVariables
    >(GetListingDataV2Document, options);
}
export type GetListingDataV2QueryHookResult = ReturnType<
    typeof useGetListingDataV2Query
>;
export type GetListingDataV2LazyQueryHookResult = ReturnType<
    typeof useGetListingDataV2LazyQuery
>;
export type GetListingDataV2QueryResult = Apollo.QueryResult<
    GetListingDataV2Query,
    GetListingDataV2QueryVariables
>;
